// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"96":"6c3a2d914c596f69b64f","811":"357f7f09f7420697d3a9"}[chunkId] + ".js");